// Mirrors trpc.stock.dashboard (apps/web/src/api/trpc/routers/stock.ts).

type FoodCostTotals = {
  revenue_net: number;
  cost: number;
  costed_share: number | null;
  cost_pct: number | null;
} | null;

export type Dashboard = {
  days: number;
  stock: {
    value: number;
    items: number;
    below_par_count: number;
    below_par: { id: number; name: string; base_unit: string; on_hand: number; par_level: number; short_pct: number }[];
  };
  food_cost: { current: FoodCostTotals; previous: FoodCostTotals };
  purchases: { total: number; previous_total: number; weeks: { week: string; total: number }[] };
  waste: { total: number; previous_total: number; reasons: { reason: string; cost: number }[] };
  invoices: { open_total: number; open_count: number; overdue_total: number; overdue_count: number; due_soon_total: number };
  orders: { awaiting: number; awaiting_value: number; late: number; due_today: number; drafts: number };
  todo: { draft_deliveries: number; last_count_at: string | null; draft_counts: number };
  price_rises: {
    id: number;
    name: string;
    supplier_name: string;
    unit: string | null;
    price: number;
    previous_price: number;
    change_pct: number;
    recorded_at: string;
  }[];
};

/** % change from previous to current (null when there's nothing to compare). */
export const changePct = (current: number, previous: number) =>
  previous > 0 ? ((current - previous) / previous) * 100 : null;
